// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dI4RaEkWkpTtbY {
  display: flex;
  flex: 1 0 31%;
  align-items: center;
  justify-content: center;
  max-width: 32%;
  min-height: 132px;
  max-height: 132px;
  margin-right: 2%;
  margin-bottom: 24px;
  border-radius: 3px;
  background-color: var(--ds-background-neutral, #091e420f);
  cursor: pointer;
}
.dI4RaEkWkpTtbY:nth-of-type(3n) {
  margin-right: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .dI4RaEkWkpTtbY {
    flex: 1 0 48%;
    max-width: 49%;
  }
  .dI4RaEkWkpTtbY:nth-of-type(3n) {
    margin-right: 2%;
  }
  .dI4RaEkWkpTtbY:nth-of-type(2n) {
    margin-right: 0;
  }
  .dI4RaEkWkpTtbY.Ve19rvkz_Ee3E6:nth-of-type(3n) {
    display: none;
  }
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .dI4RaEkWkpTtbY {
    flex: auto;
    width: 100%;
    max-width: none;
    height: auto;
    margin-right: 0;
  }
}
@media only screen and (max-width: 750px) {
  .dI4RaEkWkpTtbY {
    width: 50vw;
  }
}
.dI4RaEkWkpTtbY:hover {
  border: none;
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
  text-decoration: none;
  color: var(--ds-text, #172b4d);
}
.dI4RaEkWkpTtbY:active {
  border: none;
  outline: 0;
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
}
.dI4RaEkWkpTtbY:active .zoowO2Pa03vvN6 {
  color: var(--ds-text, #172b4d);
}
.dI4RaEkWkpTtbY:active svg circle {
  stroke: var(--ds-text, #172b4d);
}
.dI4RaEkWkpTtbY a {
  color: var(--ds-link, #0c66e4);
}
.dI4RaEkWkpTtbY a:hover {
  text-decoration: underline;
}
.dI4RaEkWkpTtbY .hjdx015rqscRB8 {
  font-size: 12px;
  text-decoration: underline;
}
.KrdG17ch8RjONC {
  margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `dI4RaEkWkpTtbY`,
	"isFeatured": `Ve19rvkz_Ee3E6`,
	"icon-sm": `zoowO2Pa03vvN6`,
	"board-tile-cta": `hjdx015rqscRB8`,
	"startWithBoardText": `KrdG17ch8RjONC`
};
export default ___CSS_LOADER_EXPORT___;
